var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo section",style:(_vm.sectionStyle)},[_c('div',{staticClass:"container"},[(_vm.photoUrl)?_c('img',{attrs:{"src":_vm.photoUrl,"alt":"logoUrl"}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }